import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addVisitorRecordAPI, visitorExitAPI, visitorGetConfigurationAPI,
    visitorListAPI, visitorUpdateConfigurationAPI
} from '../api-requests/visitor';
import {
    addVisitorRecordRequestError, addVisitorRecordRequestSuccess, getVisitorConfigurationRequestError,
    getVisitorConfigurationRequestSuccess, updateVisitorConfigurationRequestError, updateVisitorConfigurationRequestSuccess,
    visitorExitRequestError, visitorExitRequestSuccess, visitorListRequestError,
    visitorListRequestSuccess
} from './visitor.action';
import { VisitorActionTypes } from './visitor.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';
import { APP_CONSTANTS } from '../../utils/AppConstants';

function* handleVisitorUpdateConfigurationRequest({ payload }) {
    try {
        const response = yield call(visitorUpdateConfigurationAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateVisitorConfigurationRequestSuccess(decryptedData))
            } else {
                yield put(updateVisitorConfigurationRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: VisitorActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updateVisitorConfigurationRequestError(error.response.data))
        }
    }
}

export function* visitorUpdateConfigurationReq() {
    yield takeLatest(VisitorActionTypes.VISITOR_UPDATE_CONFIGURATION_REQUEST, handleVisitorUpdateConfigurationRequest)
}

function* handleVisitorListRequest({ payload }) {
    try {
        const response = yield call(visitorListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(visitorListRequestSuccess(decryptedData))
            } else {
                yield put(visitorListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: VisitorActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(visitorListRequestError(error.response.data))
        }
    }
}

export function* visitorListReq() {
    yield takeLatest(VisitorActionTypes.VISITOR_LIST_REQUEST, handleVisitorListRequest)
}

function* handleVisitorGetConfigurationRequest({ payload }) {
    try {
        const response = yield call(visitorGetConfigurationAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(getVisitorConfigurationRequestSuccess(decryptedData))
            } else {
                yield put(getVisitorConfigurationRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: VisitorActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(getVisitorConfigurationRequestError(error.response.data))
        }
    }
}

export function* visitorGetConfigurationReq() {
    yield takeLatest(VisitorActionTypes.VISITOR_GET_CONFIGURATION_REQUEST, handleVisitorGetConfigurationRequest)
}

function* handleVisitorExitRequest({ payload }) {
    try {
        const response = yield call(visitorExitAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(visitorExitRequestSuccess(decryptedData))
            } else {
                yield put(visitorExitRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: VisitorActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(visitorExitRequestError(error.response.data))
        }
    }
}

export function* visitorExitReq() {
    yield takeLatest(VisitorActionTypes.VISITOR_MARK_EXIT_REQUEST, handleVisitorExitRequest)
}

function* handleAddVisitorRecordRequest({ payload }) {
    try {
        const response = yield call(addVisitorRecordAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addVisitorRecordRequestSuccess(decryptedData))
            } else {
                yield put(addVisitorRecordRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: VisitorActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(addVisitorRecordRequestError(error.response.data))
        }
    }
}

export function* addVisitorRecordReq() {
    yield takeLatest(VisitorActionTypes.ADD_VISITOR_RECORD_REQUEST, handleAddVisitorRecordRequest)
}